import { createSlice } from '@reduxjs/toolkit';
import type { AsyncStatus } from '@/shared/types/asyncState';
import type { PlataformaLog } from '../../types/plataforma';
import { fetchPlataformaLogs } from './actions';

interface PlataformaLogsState {
  logs: PlataformaLog[];
  loading: boolean;
  error: string | null;
  status: AsyncStatus;
}

const initialState: PlataformaLogsState = {
  logs: [],
  loading: false,
  error: null,
  status: 'idle',
};

const plataformaLogsSlice = createSlice({
  name: 'plataformaLogs',
  initialState,
  reducers: {
    resetPlataformaLogs: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlataformaLogs.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.status = 'loading';
      })
      .addCase(fetchPlataformaLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.logs = action.payload.logs;
        state.status = 'success';
      })
      .addCase(fetchPlataformaLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'Erro desconhecido';
        state.status = 'error';
      });
  },
});

export const { resetPlataformaLogs } = plataformaLogsSlice.actions;
export const plataformaLogsReducer = plataformaLogsSlice.reducer;
